import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getAdminSession } from '../lib/auth';

export function ProtectedRoute() {
  const loc = useLocation();
  const session = getAdminSession();
  if (!session) {
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  }
  return <Outlet />;
}
